import { Key, useCallback, useEffect, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { IEpUploadTranslations } from '../../interfaces';
import { EpButton } from '../EpButton';
import './EpUpload.scss';

/* eslint-disable  @typescript-eslint/no-explicit-any */

interface EpUploadProps {
  uploadId: string;
  uploadButtonIcon?: string;
  uploadMaxFiles?: number;
  uploadMaxFilesSize?: number;
  uploadFilesCallbackFunc?: (file: File[]) => void;
  files?: File[];
  customClasses?: string;
  translations?: IEpUploadTranslations;
}

export const EpUpload = ({
  uploadId,
  uploadButtonIcon,
  uploadMaxFiles = 10,
  uploadMaxFilesSize = 10,
  uploadFilesCallbackFunc,
  files,
  customClasses = '',
  translations = {
    uploadButtonText: '',
    noFileSelectedText: '',
    selectedFileText: '',
    uploadMaxFilesText: '',
    uploadMaxFilesSizeText: '',
  },
}: EpUploadProps) => {
  const [selectedFiles, setSelectedFiles] = useState<File[]>(files || []);
  const onDrop = useCallback(
    async (acceptedFiles: File[]) => {
      const selectedFilesLength = selectedFiles.length + acceptedFiles.length;
      if (selectedFilesLength <= uploadMaxFiles) {
        const filePromises = acceptedFiles.map((file) => {
          return new Promise((resolve) => {
            const reader = new FileReader();
            reader.onload = () => {
              if (typeof reader.result === 'string') {
                const base64Data = reader.result.split(',')[1];
                const resolveData = `data:${file?.type};base64,${base64Data}`;
                let arr = file;
                arr = Object.assign({
                  FileName: file?.name,
                  Base64File: resolveData,
                });
                resolve(arr);
              }
            };
            reader.readAsDataURL(file);
          });
        });

        const fileData: any = await Promise.all(filePromises);
        setSelectedFiles((prevSelectedFiles) => [
          ...prevSelectedFiles,
          ...fileData,
        ]);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [selectedFiles, setSelectedFiles],
  );

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    maxFiles: uploadMaxFiles,
    maxSize: uploadMaxFilesSize * 1000000,
    accept: {
      'image/jpeg': ['.jpeg', '.jpg', '.png'],
      'application/pdf': ['.pdf'],
      'application/msword': [],
    },
  });

  const uploadButtonText = translations.uploadButtonText || '';
  const noFileSelectedText = translations.noFileSelectedText || '';
  const selectFileText = translations.selectedFileText || '';
  // const uploadMaxFilesText = translations.uploadMaxFilesText || '';
  const uploadMaxFilesSizeText = translations.uploadMaxFilesSizeText || '';

  const removedfile = (file: File) => {
    setSelectedFiles((prevSelectedFiles) => prevSelectedFiles.filter((selectedFile) => selectedFile !== file),
    );
  };

  useEffect(() => {
    if (selectedFiles) {
      uploadFilesCallbackFunc?.([...selectedFiles]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFiles]);

  return (
    <div id={uploadId} className={`ep-upload ${customClasses}`}>
      <div className="ep-upload__choose-file choose-file">
        <div className="choose-file__upload-container upload-container">
          <input {...getInputProps()} />
          <div {...getRootProps()}>
            <EpButton
              buttonId="upload-container__button--choose-file"
              buttonType="primary-outline"
              buttonSize="md"
              buttonText={uploadButtonText}
              buttonLeftIconName={uploadButtonIcon}
            />
          </div>
          <p className="upload-container__file-text">
            {selectedFiles.length === 0
              ? noFileSelectedText
              : selectFileText.replace('{0}', selectedFiles.length.toString())}
          </p>
        </div>
        <small className="choose-file__limit-text">
          {/* {uploadMaxFiles
            ? uploadMaxFilesText.replace('{0}', uploadMaxFiles.toString())
            : ''} */}
          {/* {uploadMaxFiles && uploadMaxFilesSize ? ' / ' : ''} */}
          {uploadMaxFilesSize
            ? uploadMaxFilesSizeText.replace(
              '{0}',
              uploadMaxFilesSize.toString(),
            )
            : ''}
        </small>
      </div>

      <div className="ep-upload__file file">
        <ul className="file__list list">
          {selectedFiles.map((file: any, index: Key) => (
            <li className="list__item item" key={index}>
              <span className="item__text">{file?.FileName}</span>
              <EpButton
                buttonId={`item__close-button--${selectedFiles.length}`}
                buttonSize="sm"
                buttonType="danger-outline"
                buttonRightIconName="SolidTimes"
                buttonOnClickFunc={() => removedfile(file as File)}
              />
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
